/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Routes, RouterModule } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';

const ROUTES: Routes = [
  {
    path: 'dashboard',
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: '',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  }
];

export const routing = RouterModule.forRoot(ROUTES);
